import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarDisable1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 15L15 19.5",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 15L19.5 19.5",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25,17.25h-6a1.5,1.5,0,0,1-1.5-1.5V3.765a1.5,1.5,0,0,1,1.5-1.5h13.5a1.5,1.5,0,0,1,1.5,1.5V8.25",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.75 6.75L17.25 6.75",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.243 3.75L5.243 0.75",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.743 3.75L12.743 0.75",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgCalendarDisable1;
